export default __webpack_public_path__ + "static/media/signup-side-image.f25f4891.png";